import React, { useState } from 'react';
import Button from 'common/components/elements/buttons/primary';
import './style.scss'
import Modal from 'common/components/modules/modal';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import google from 'assets/images/social-media/google.png';
import twitter from 'assets/images/social-media/twitter-x.svg';
// import sharesome from 'assets/images/social-media/sharesome.png';
import avatar from 'assets/images/avatar.svg';
import toast from 'common/utils/toast';
import Input from 'common/components/elements/inputs/inputs';
import ReCAPTCHA from 'react-google-recaptcha';
import SecondModal from 'common/components/modules/information-and-policies/modal';
import cx from 'classnames'
import twitterLight from 'assets/images/social-media/twitter-x-light.svg';
import CircleLoader from 'common/components/elements/loader/circle';

const BlockedSignIn = ({
   screenWidth,
   onClose,
   onClickButton,
   email,
   password,
   onInputChange,
   onLogin,
   saved,
   loading,
   errors,
   gotToSignUp,
   forgotPassword,
   isCaptchaEnabled,
   isDemoMode,
}) => {
   const [showForm, setShowForm] = useState(false)

   const [recaptchaVal, setRecaptchaVal] = useState(null)
   const [isRecaptchaInited, setIsRecaptchaInited] = useState(false)

   const [openInformationModal, setOpenInformationModal] = useState(false);

   function onChangeRecaptcha(value) {
      setRecaptchaVal(value)
      // console.log("Captcha value:", value);
   }
   function handleSubmit(e){
      e.preventDefault();
      if(isCaptchaEnabled && !recaptchaVal) {
         toast.error('Check the checkbox')
         return;
      }
      onLogin()
   }
   return (
      <Modal
         contentPosition={ screenWidth < 701  ? 'bottom' : 'center' }
         onClose={ onClose }
         otherclassName='h-[fit-content] overflow-hidden '
         contentWidth={ screenWidth < 701  ? '100%' : '391px' }
         closeOnClickOutside={ true }
      >
         <div className={ 'flex p-6 items-center justify-center' }>
            {
               !showForm ?
                  (
                     <div className='sign-in-items-wrapper w-full ms:w-[327px]'>
                        <div className='w-full flex items-center justify-center my-6'>
                           <span className='text-2xl leading-tight text-major dark:text-major-dark'>
                              Sign in
                           </span>
                        </div>
                        <div
                           className='w-full h-10 border cursor-pointer border-divider dark:border-divider-dark rounded-lg flex items-center justify-center'
                           role='presentation'
                           onClick={ () => {
                              onClickButton('email')
                              setShowForm(true)
                           } }
                        >
                           <Icon
                              name='message'
                              size='2xl'
                           />
                           <div className='flex items-center justify-center ml-4'>
                              <span className='leading-tight text-major dark:text-major-dark'> Sign in with email address</span>
                           </div>
                        </div>
                        <div className='justify-center items-center flex w-full my-4'>
                           <div className='border-t border-divider dark:border-divider-dark h-0 w-1/2 mr-4' />
                           <p className='text-sm leading-18 font-medium text-placeholder dark:text-placeholder-dark whitespace-nowrap'>OR</p>
                           <div className='border-t border-divider dark:border-divider-dark h-0 w-1/2 ml-4' />
                        </div>
                        <div className='mb-4'>
                           <Item
                              text={  `Sign in with Google` }
                              onClick={ () => !isDemoMode && onClickButton('google') }
                              image={ google }
                              isDemoMode={ isDemoMode }
                           />
                        </div>
                        <div className='mb-4'>
                           <Item
                              text={  `Sign in with X` }
                              onClick={ () => !isDemoMode && onClickButton('twitter') }
                              image={ window?.site_dark_bg ? twitterLight : twitter }
                              isDemoMode={ isDemoMode }
                           />
                        </div>
                        {/* <div className='mb-4'>
                           <Item
                              text={  `Sign in with Sharesome` }
                              onClick={ () => !isDemoMode && onClickButton('sharesome') }
                              image={ sharesome }
                              isDemoMode={ isDemoMode }
                           />
                        </div> */}
                        <div className='p-4 flex bg-success-12 dark:bg-success-dark-12'>
                           <div className='w-10 h-10'>
                              <div className='w-10 h-10 bg-success dark:bg-success-dark rounded-full flex items-center justify-center'>
                                 <Icon name='lock' color='major-dark' size='2xl' />
                              </div>
                           </div>
                           <div className='text-success dark:text-success-dark ml-4 text-sm leading-tight'>
                              <span className='block font-medium mb-4'>Your data and privacy is protected</span>
                              <div>
                                 <span className=''>We take the protection of your privacy and confidentiality seriously. We ONLY request your email address to facilitate the login process.
                                    For more see our
                                 </span>
                                 <div
                                    className='inline-block cursor-pointer'
                                    role='presentation'
                                    onClick={ () => {
                                       setOpenInformationModal(true)
                                    } }
                                 >
                                    <span className='hover:underline'>Privacy policy.</span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  )
                  :
                  (
                     <>
                        <div className='ms:w-116 w-full'>
                           <div className='w-full flex items-center justify-center mt-6'>
                              <span className='text-xl leading-6 font-medium text-major dark:text-major-dark'>
                                 Sign in
                              </span>
                           </div>
                           {
                              saved && (
                                 <div className='login-avatar mt-10'>
                                    <img src={ avatar } alt='avatar' />
                                    <p className='font-bold text-center mt-4 text-xl'>Princess Leia</p>
                                 </div>
                              )
                           }
                           <form onSubmit={ handleSubmit }>
                              {
                                 !saved &&
                                    <div className='mt-6 relative'>
                                       <Input
                                          onChange={ (name, value) => onInputChange(name, value) }
                                          label='Email'
                                          type='email'
                                          placeholder='Enter your email'
                                          name='email'
                                          iconName='message'
                                          value={ email }
                                          errorMessage={ !!errors.email  ?  errors.email[0] : '' }
                                          hideError={ !!errors.error }
                                          height={ `10` }
                                          iconClassName={ `!my-2` }
                                       />
                                    </div>
                              }

                              <div className='mt-6'>
                                 <Input
                                    onChange={ (name, value) => onInputChange(name, value) }
                                    label='Password'
                                    type='password'
                                    placeholder='Enter password'
                                    iconName='password'
                                    name='password'
                                    value={ password }
                                    errorMessage={ !!errors.password ?  errors.password[0] : '' }
                                    hideError={ !!errors.error }
                                    showPasswordIcon
                                    height={ `10` }
                                    iconClassName={ `!my-2` }
                                 />
                              </div>
                              {
                                 isCaptchaEnabled && (
                                    <>
                                       {
                                          !isRecaptchaInited && (
                                             <div
                                                className='mt-4 px-3 min-h-[78px] w-[304px] flex items-center justify-start'
                                             >
                                                <CircleLoader
                                                   color='primary'
                                                   size={ 8 }
                                                />

                                             </div>
                                          )
                                       }
                                       <ReCAPTCHA
                                          sitekey='6LdyFGAlAAAAAF3JDerNu72sdn8et8k8Bo4OyvJY'
                                          onChange={ onChangeRecaptcha }
                                          className={ cx({
                                             'mt-4': true,
                                             'hidden': !isRecaptchaInited,
                                          }) }
                                          asyncScriptOnLoad={ () => {
                                             setTimeout(() => {
                                                setIsRecaptchaInited(true)
                                             }, 1000)
                                          } }
                                       />
                                    </>
                                 )
                              }
                              <div className='mt-6'>
                                 {
                                    errors && errors.error && (
                                       <span
                                          className='text-error dark:text-error-dark block leading-none select-none h-4 mb-2 text-center'>
                                          {
                                             errors && errors.error && (
                                                errors.error
                                             )
                                          }
                                       </span>
                                    )
                                 }
                                 <div>
                                    <Button
                                       text='Sign in'
                                       type='submit'
                                       borderRadius='large'
                                       isLoading={ loading }
                                       primaryColor
                                       classNames='h-10'
                                       textSize='base'
                                       disabled={ isDemoMode }
                                       dataToolTipContent={ isDemoMode ? 'Not available in demo' : '' }
                                    />
                                 </div>
                              </div>
                           </form>
                           <div className='h-10 mt-3 login-translate'>
                              <Button
                                 text='See all sign in options'
                                 onClick={ () => setShowForm(false) }
                                 borderRadius='large'
                                 backgroundColor='transparent'
                                 primaryColor
                                 classNames='h-10'
                                 padding='none'
                                 textSize='base'
                              />
                           </div>
                        </div>
                     </>
                  )
            }
            {
               !!openInformationModal && (
                  <SecondModal
                     title={ 'Privacy Policy' }
                     onClose={ () => setOpenInformationModal('') }
                     type='sites'
                  />
               )
            }
         </div>
      </Modal>
   );
};

export const Item = ({
   image,
   text,
   onClick,
   isDemoMode,
}) => {
   return (
      <div
         className={ cx({
            'w-full h-10 border cursor-pointer border-divider dark:border-divider-dark rounded-lg flex items-center justify-center': true,
            '!cursor-default !border-disabled dark:!border-disabled-dark !text-disabled dark:!text-disabled-dark': isDemoMode,
         }) }
         role='presentation'
         onClick={ onClick }
         data-tooltip-content={ isDemoMode ? 'Not available in demo' : '' }
         data-tooltip-id='ams-top-tooltip'
      >
         <div className='w-6 h-6 flex items-center justify-center rounded-full mr-4'>
            <img
               src={ image }
               alt=''
               className={ cx({
                  'opacity-32': isDemoMode,
               }) }
            />
         </div>
         <div className='flex items-center justify-center'>
            <span className='leading-tight'>{text}</span>
         </div>
      </div>
   )
}

BlockedSignIn.propTypes = {
   screenWidth: PropTypes.number,
   onClose: PropTypes.func,
   onClickButton: PropTypes.func,
   email: PropTypes.string.isRequired,
   password: PropTypes.string.isRequired,
   onInputChange: PropTypes.func.isRequired,
   onLogin: PropTypes.func.isRequired,
   loading: PropTypes.bool,
   errors: PropTypes.object,
   gotToSignUp: PropTypes.func,
   forgotPassword: PropTypes.func,
   saved: PropTypes.bool,
   isCaptchaEnabled: PropTypes.bool,
   isDemoMode: PropTypes.bool,
}

Item.propTypes = {
   image: PropTypes.string,
   text: PropTypes.string,
   onClick: PropTypes.func,
   isDemoMode: PropTypes.bool,
};

export default BlockedSignIn;
